import React from "react";
const ReportsMaintenance: React.FC = (props) => {
    return (
        <h1>Reports Maintenance</h1>
    )
}
export default ReportsMaintenance